/**
 * 정정 요청 페이지 화면 렌더러 — Defense.js 에서 분리.
 *
 * 클로저 상태 S 와 컴포넌트 묶음 C(header/urgencyBanner/reportTable/faqSection)를
 * 팩토리 인자로 주입받는다. 아이콘(ICall/IChv 등)은 icons.js 에서.
 * 소명 트랙 화면(소명서·검토중·소명 반려·회수 완료)은 2026-10 폐지 — 정정 요청서(NotmeForm BS)와 그 결과 화면만 남는다.
 */
import { IB, IX, ICall, IChv } from './icons';
import Util from '../../../Common/Util';

export function makeScreens(S, C) {
    const { header, urgencyBanner, reportTable, faqSection } = C;

        function _stubScr(label, title) {
            return `<div class="scr fi">
              ${header(title || label, true)}
              ${urgencyBanner()}
              <div style="flex:1;display:flex;align-items:center;justify-content:center;padding:24px;text-align:center">
                <div>
                  <p style="font-size:14px;color:var(--t2);line-height:1.7">화면 구현 중…</p>
                  <p style="font-size:12px;color:var(--t2);margin-top:8px;font-family:monospace">${label}</p>
                </div>
              </div>
            </div>`;
        }
        // rAuthFirst — 소명 기회 안내: 제보 요약 + ① 소명(제보자와 통화, 안심번호) + ② 정정(본인 아님 요청) + ③ 무응답 안내
        //   기획 확정 2026-10-02: 소명은 업체↔제보자 통화로 풀고 플랫폼엔 기록을 남기지 않는다. 버튼 이름은 "제보자와 통화" / "정정 요청하기".
        function rAuthFirst() {
            const r = S.report;
            return `<div class="scr fi">
              ${header('소명 기회 안내', true)}
              ${urgencyBanner()}
              <div class="noscr" style="flex:1;overflow-y:auto;padding:16px 16px 30px;display:flex;flex-direction:column;gap:12px">
                <!-- 제보 요약 -->
                <div style="background:var(--sf);border:2px solid var(--R);border-radius:14px;padding:16px;display:flex;flex-direction:column;gap:12px">
                  <div style="display:flex;align-items:center;gap:8px">
                    <p style="font-size:13px;color:var(--t2);font-weight:600">등록일 ${Util.escapeHtml(r.registeredAt)}</p>
                  </div>
                  ${reportTable()}
                  <!-- 현재 단계 안내 -->
                  <div style="background:var(--Rl);border:1px solid var(--Rg);border-radius:12px;padding:12px 16px">
                    <p style="font-size:12px;color:var(--t2);line-height:1.6;text-align:center;margin:0">ⓘ 현재는 <strong style="color:var(--t1)">소명·정정 단계</strong>로, 아직 체불 확정 상태가 아닙니다.</p>
                  </div>
                  <!-- 면책 문구 (2026-10-30 대표님·CS 확정) — 제보 제출 확인창(Report.js confirmSubmit)과 같은 문장. 장비불러는 자료를 전달만 하고 판단·보증·수금하지 않는다 -->
                  <p style="font-size:12px;color:var(--t2);line-height:1.6;text-align:center;margin:0">장비불러는 제출된 자료를 전달할 뿐, 대금을 받아 주거나 사실 여부를 판단·보증하지 않습니다.</p>
                </div>

                <!-- ① 소명 — 제보자와 통화 (안심번호) -->
                <div style="background:var(--sf);border:1px solid var(--bdr);border-radius:14px;padding:14px 16px;display:flex;flex-direction:column;gap:8px">
                  <p style="font-size:14px;font-weight:700;color:var(--t1);margin:0">① 소명 — 사실과 다르거나 지급·합의로 해결</p>
                  <p style="font-size:12px;color:var(--t2);line-height:1.6;margin:0">제보자와 직접 통화해 주세요. 합의되면 제보자가 철회를 요청합니다.</p>
                  <button class="call-reg-btn btn-act btn-act-fill">
                    ${ICall()}제보자와 통화
                  </button>
                </div>

                <!-- ② 정정 — 본인(귀사)이 아님 -->
                <div style="background:var(--sf);border:1px solid var(--bdr);border-radius:14px;padding:14px 16px;display:flex;flex-direction:column;gap:8px">
                  <p style="font-size:14px;font-weight:700;color:var(--t1);margin:0">② 정정 — 본인(귀사)이 아님</p>
                  <p style="font-size:12px;color:var(--t2);line-height:1.6;margin:0">명의가 잘못됐거나 번호를 승계한 경우</p>
                  <button id="go-notme" class="btn-act btn-act-out">정정 요청하기</button>
                </div>

                <!-- ③ 무응답 -->
                <div style="border:1px dashed var(--bdr);border-radius:12px;padding:10px 14px;text-align:center">
                  <p style="font-size:12px;color:var(--t2);line-height:1.6;margin:0">③ 기한 안에 소명·정정이 없으면 체불업체로 등록됩니다.</p>
                </div>

                <div style="margin:0 -16px">${faqSection(true)}</div>
              </div>
            </div>`;
        }

        // rAuthFormInner — SMS 본인 인증 폼 본문(안내 + 휴대폰 인증). full 화면(rAuthReturn)과
        //   바텀시트(Defense.js openAuthSheet) 공용 — header/urgencyBanner/FAQ 중복 제거용.
        function rAuthFormInner() {
            return `<!-- 안내 -->
                <div style="background:var(--sf2);border-radius:12px;padding:14px">
                  <p style="font-size:14px;font-weight:700;color:var(--t1);margin-bottom:8px">📱 본인 인증이 필요합니다</p>
                  <p style="font-size:12px;color:var(--t2);line-height:1.7">개인정보 보호를 위해 휴대폰 본인 인증 후 제보자 통화·정정 요청서 작성·진행현황 확인이 가능합니다.</p>
                </div>

                <!-- SMS 인증 폼 -->
                <div style="background:var(--sf);border:2px solid var(--R);border-radius:14px;padding:16px;display:flex;flex-direction:column;gap:16px">
                  <p class="sec-t-lg" style="display:flex;align-items:center;gap:8px">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="6" y="2" width="12" height="20" rx="2" stroke="var(--R)" stroke-width="1.8"/><circle cx="12" cy="18" r="1" fill="var(--R)"/></svg>
                    휴대폰 본인 인증
                  </p>

                  <!-- 휴대폰 번호 -->
                  <div>
                    <div class="lbl">휴대폰 번호 <i>*</i></div>
                    <div style="display:flex;gap:8px;align-items:stretch">
                      <input id="auth-phone" class="inp" type="tel" inputmode="numeric" placeholder="010-1234-5678" value="${Util.phoneNumber(S.authPhone)}" maxlength="13" ${S.authSent ? 'disabled' : ''} style="flex:1">
                      <button id="send-auth-code" style="padding:0 14px;border-radius:14px;border:none;background:${S.authSent ? 'var(--sf2)' : 'var(--grad)'};color:${S.authSent ? 'var(--t2)' : 'var(--on-brand)'};font-size:13px;font-weight:700;cursor:pointer;white-space:nowrap;min-width:90px">${S.authSent ? '재발송' : '인증번호 발송'}</button>
                    </div>
                    <p id="auth-phone-msg" style="font-size:11px;color:var(--t2);margin-top:8px">※ 문자를 받으신 본인 명의의 휴대폰 번호를 입력해 주세요.</p>
                  </div>

                  <!-- 인증번호 입력 (발송 후 노출) -->
                  <div id="auth-code-area" style="display:${S.authSent ? 'block' : 'none'}">
                    <div class="lbl">인증번호 <i>*</i> <span id="auth-timer" style="font-weight:400;color:var(--R);font-size:11px;margin-left:6px">3:00</span></div>
                    <input id="auth-code" class="inp" type="tel" inputmode="numeric" placeholder="6자리 숫자" maxlength="6" value="${Util.escapeHtml(S.authCode)}">
                    <p id="auth-msg" style="font-size:11px;color:var(--t2);margin-top:8px">문자로 받은 인증번호 6자리를 입력해 주세요.</p>
                  </div>

                  <button id="auth-confirm" ${S.authSent ? '' : 'disabled'} style="height:48px;border-radius:14px;border:none;background:${S.authSent ? 'var(--grad)' : 'var(--bdr2)'};color:var(--on-brand);font-size:15px;font-weight:700;cursor:${S.authSent ? 'pointer' : 'not-allowed'}">확인</button>
                </div>`;
        }

        // rAuthReturn — SMS 본인 인증 full 화면(재접속 게이트용). 폼 본문은 rAuthFormInner 공용.
        function rAuthReturn() {
            return `<div class="scr fi">
              ${header('본인 인증', true)}
              ${urgencyBanner()}
              <div class="noscr" style="flex:1;overflow-y:auto;padding:16px 16px 30px;display:flex;flex-direction:column;gap:16px">
                ${rAuthFormInner()}
                <div style="margin:0 -16px">${faqSection()}</div>
              </div>
            </div>`;
        }

        // (정정 요청서 폼은 Defense/NotmeForm.js (BottomSheet) 가 렌더)

        // rNotMeDone — 정정 요청 접수 완료 + 제출 자료 요약
        function rNotMeDone() {
            return `<div class="scr fi">
              ${header('정정 요청', true)}
              <div class="noscr" style="flex:1;overflow-y:auto;padding:0 0 30px">

                <div style="padding:16px;background:var(--bg)">
                  <div class="status-box success" style="background:var(--Cg);border:1px solid var(--C);border-radius:12px;padding:14px">
                    <p style="font-size:15px;font-weight:700;color:var(--C);display:flex;align-items:center;gap:8px">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8" fill="var(--C)"/><path d="M5 9l3 3 5-6" stroke="var(--on-brand)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      정정 요청 접수 완료
                    </p>
                    <p style="font-size:12px;color:var(--t2);line-height:1.6;margin-top:8px">관리자가 검토합니다. 결과는 문자 또는 담당자 전화로 안내드립니다. <b style="color:var(--t1)">서류로 본인 명의 입증이 어려운 경우 반려될 수 있습니다.</b></p>
                  </div>
                </div>

                <!-- 요청 내역 -->
                <div style="padding:0 16px 16px">
                  <div style="border:2px solid var(--R);border-radius:14px;padding:16px;background:var(--sf)">
                    <p class="sec-t-lg" style="display:flex;align-items:center;gap:8px;margin-bottom:12px">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 2L2 7v6c0 5 4 8 10 9 6-1 10-4 10-9V7L12 2z" stroke="var(--R)" stroke-width="1.8" stroke-linejoin="round" fill="none"/></svg>
                      요청 내역
                    </p>
                    <div class="tbl">
                      <div class="tbl-row"><div class="tbl-tit">이름</div><div class="tbl-val">${Util.escapeHtml(S.userName || '홍길동')}</div></div>
                      <div class="tbl-row"><div class="tbl-tit">연락처</div><div class="tbl-val">${Util.phoneNumber(S.authPhone || S.reportPhone)}</div></div>
                      <div class="tbl-row col">
                        <div class="tbl-tit">증빙 서류</div>
                        <div class="tbl-val" style="padding:12px 14px">
                          <div class="ph-grid">
                            ${S.notmePhotos.length
                                ? S.notmePhotos.map((p, i) => `<div class="ph-thumb" data-pi="${i}" data-pg="notme"><img src="${Util.escapeHtml(p.url)}"><div class="ph-zoom-ic" style="position:absolute;bottom:4px;left:4px;width:22px;height:22px;border-radius:6px;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;pointer-events:none"><svg width="12" height="12" viewBox="0 0 14 14" fill="none"><path d="M1 9v4h4M13 5V1H9M1 13L5.5 8.5M13 1L8.5 5.5" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/></svg></div></div>`).join('')
                                : [1, 2, 3].map(() => '<div class="ph-thumb" style="cursor:default;pointer-events:none"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="3" stroke="var(--bdr2)" stroke-width="1.3"/><circle cx="8" cy="8" r="2" stroke="var(--bdr2)" stroke-width="1.3"/><path d="M2 16l5-4 4 4 3-3 8 7" stroke="var(--bdr2)" stroke-width="1.3"/></svg></div>').join('')}
                          </div>
                        </div>
                      </div>
                      <div class="tbl-row col"><div class="tbl-tit">사유</div><div class="tbl-val" style="line-height:1.6">${Util.escapeHtml(S.notmeReason || '-')}</div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>`;
        }

        // rNotMeApproved — 정정 요청 처리 완료 (검색 노출 제외)
        function rNotMeApproved() {
            return `<div class="scr fi">
              ${header('정정 요청', true)}
              <div class="noscr" style="flex:1;overflow-y:auto;padding:0 0 30px">
                <div style="padding:16px 16px 0">
                  <div style="background:var(--sf);border:1.5px solid var(--C);border-radius:14px;overflow:hidden">
                    <div style="background:var(--Cg);padding:14px 16px;border-bottom:1px solid var(--C)">
                      <p style="font-size:15px;font-weight:800;color:var(--C);display:flex;align-items:center;gap:8px">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="9" fill="var(--C)"/><path d="M5 9l3 3 5-6" stroke="var(--on-brand)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        정정 요청 처리 완료
                      </p>
                      <p style="font-size:11px;color:var(--t2);margin-top:4px;padding-left:24px">본인 아님 확인 · 검색 노출 제외</p>
                    </div>
                    <div style="padding:14px 16px">
                      <p style="font-size:13px;color:var(--t1);line-height:1.7;margin-bottom:12px">제출하신 자료가 확인되어 <strong style="color:var(--C)">정정 처리</strong>되었습니다. 검색 노출에서 제외됩니다.</p>
                      <p style="font-size:13px;color:var(--t1);line-height:1.7">협조해 주셔서 감사합니다.</p>
                      <p style="font-size:11px;color:var(--t2);margin-top:12px">※ 해당 페이지는 15일간 확인 가능하며, 이후 링크가 삭제됩니다.</p>
                    </div>
                  </div>
                </div>
                ${faqSection()}
              </div>
            </div>`;
        }

        // rNotMeRejected — 정정 요청 반려 + 사유. 재제출은 없다(기획 2026-10-01) — 담당자가 전화로 안내.
        function rNotMeRejected() {
            const r = S.report;
            return `<div class="scr fi">
              ${header('정정 요청', true)}
              <div class="noscr" style="flex:1;overflow-y:auto;padding:0 0 30px">
                <div style="padding:16px 16px 0">
                  <div style="background:var(--sf);border:1.5px solid var(--bdr);border-radius:14px;overflow:hidden">
                    <div style="background:var(--Og);padding:12px 16px;border-bottom:1px solid var(--bdr);display:flex;align-items:center;justify-content:space-between;gap:8px">
                      <p style="font-size:15px;font-weight:800;color:var(--O);display:flex;align-items:center;gap:8px">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8" stroke="var(--O)" stroke-width="1.6"/><path d="M9 5v4.5M9 12v.5" stroke="var(--O)" stroke-width="1.8" stroke-linecap="round"/></svg>
                        정정 요청 반려
                      </p>
                      <p style="font-size:11px;color:var(--t2);white-space:nowrap">${Util.escapeHtml(r.rejectedAt)}</p>
                    </div>
                    <div style="padding:14px 16px">
                      <p style="font-size:13px;color:var(--t1);line-height:1.8;margin-bottom:12px">${Util.escapeHtml(r.notmeRejectReason)}</p>
                      <div style="background:var(--sf2);border-radius:8px;padding:10px 12px">
                        <p style="font-size:12px;color:var(--t2);line-height:1.6">제출하신 자료로는 정정이 확인되지 않았습니다. <strong style="color:var(--O)">담당자가 전화로 안내</strong>드리니 통화를 받아 주세요. 요청 기한 내 확인되지 않으면 체불업체(자)로 등록될 수 있습니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
                ${faqSection()}
              </div>
            </div>`;
        }

        // rRegistered — 정정 요청 기한 만료 / 체불업체 정식 등록 (종단 화면)
        function rRegistered() {
            return `<div class="scr fi" style="background:var(--sf2)">
              ${header('페이지 종료', false)}
              <div class="noscr" style="flex:1;overflow-y:auto;padding:0;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;background:var(--sf2)">
                <div style="padding:40px 20px;display:flex;flex-direction:column;align-items:center;gap:20px;width:100%;box-sizing:border-box">
                  <div style="width:72px;height:72px;border-radius:50%;background:var(--sf3);display:flex;align-items:center;justify-content:center">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <rect x="7" y="14" width="18" height="14" rx="2" stroke="var(--t2)" stroke-width="2"/>
                      <path d="M11 14V10a5 5 0 0110 0v4" stroke="var(--t2)" stroke-width="2" stroke-linecap="round"/>
                      <circle cx="16" cy="21" r="1.5" fill="var(--t2)"/>
                    </svg>
                  </div>
                  <div>
                    <p style="font-size:18px;font-weight:700;color:var(--t1);margin-bottom:8px">소명·정정 기한이 만료되었습니다</p>
                    <p style="font-size:13px;color:var(--t3);line-height:1.6">체불업체로 등록되어 페이지가 종료됩니다.</p>
                  </div>
                  <div style="background:var(--sf);border:1px solid var(--bdr);border-radius:12px;padding:14px 16px;width:100%;text-align:left">
                    <p style="font-size:12px;color:var(--t2);line-height:1.8">
                      • 회수 요청은 <strong style="color:var(--t1)">제보자에게 직접 문의</strong>해 주세요.<br>
                      • <strong style="color:var(--t1)">고객센터에서는 처리가 불가능</strong>합니다.<br>
                      • 15일 후 페이지가 <strong style="color:var(--t1)">자동 삭제</strong>되어 접속할 수 없습니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>`;
        }

        // rRecalled — 신고 철회(등록 해제) 종단 화면. 철회 안내 문자의 링크로 들어오면 여기.
        function rRecalled() {
            return `<div class="scr fi" style="background:var(--sf2)">
              ${header('페이지 종료', false)}
              <div class="noscr" style="flex:1;overflow-y:auto;padding:0;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;background:var(--sf2)">
                <div style="padding:40px 20px;display:flex;flex-direction:column;align-items:center;gap:20px;width:100%;box-sizing:border-box">
                  <div style="width:72px;height:72px;border-radius:50%;background:var(--Cg);display:flex;align-items:center;justify-content:center">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="13" stroke="var(--C)" stroke-width="2"/><path d="M10 16l4 4 8-9" stroke="var(--C)" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </div>
                  <div>
                    <p style="font-size:18px;font-weight:700;color:var(--t1);margin-bottom:8px">제보가 철회되었습니다</p>
                    <p style="font-size:13px;color:var(--t3);line-height:1.6">체불업체 등록이 해제되어 더 이상 조회되지 않습니다.</p>
                  </div>
                  <div style="background:var(--sf);border:1px solid var(--bdr);border-radius:12px;padding:14px 16px;width:100%;text-align:left">
                    <p style="font-size:12px;color:var(--t2);line-height:1.8">
                      • 철회 사유와 주체는 받으신 <strong style="color:var(--t1)">안내 문자</strong>에 적혀 있습니다.<br>
                      • 15일 후 페이지가 <strong style="color:var(--t1)">자동 삭제</strong>되어 접속할 수 없습니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>`;
        }

    return {
        _stubScr, rAuthFirst, rAuthReturn, rAuthFormInner,
        rNotMeDone, rNotMeApproved, rNotMeRejected, rRegistered, rRecalled,
    };
}
